module.exports = __webpack_public_path__ + "img/contactos.f63f619e.svg";